module.exports = __webpack_public_path__ + "static/media/historical-marker-ground-water.b206b839.svg";